<template>
  <van-popup
    class="advertisement_-conter"
    v-model="$store.state.CancelIsSigned_days"
    z-index="2300"
  >
    <!-- CancelDisplay -->
    <div class="ZAJ3tO484KoZnr7Y6n_l">
      <div style="position: relative; height: 1.378rem; width: 100%">
        <div
          style="
            position: absolute;
            right: 3rem;
            bottom: 0;
            left: 0;
            z-index: 10;
            height: 0.86rem;
            background: var(--theme-text-color-darken);
            border-top-left-radius: 0.2rem;
          "
        ></div>
        <div
          style="
            position: absolute;
            right: 4.23rem;
            bottom: 0;
            left: 0;
            z-index: 12;
            height: 0.86rem;
            padding: 0 0 0 0.4rem;
            font-weight: 700;
            font-size: 0.24rem;
            text-align: left;
            display: flex;
            align-items: center;
          "
        >
          {{ $t('common.mineText3') }}
        </div>
        <img
          src="../../assets/mine30/checkInBg.webp"
          alt=""
          style="
            position: relative;
            bottom: 0;
            z-index: 11;
            float: right;
            width: 4.9rem !important;
          "
        />
      </div>
    </div>
    <div
      class="advertisement_list _border"
      style="
        overflow: hidden;
        border-radius: 0.2rem;
        padding: 0.25rem 0.2rem 0.2rem;
        background: var(--theme-text-color-darken);
      "
    >
      <div class="xmHlf3AdKNfopQZxGTk7">
        <div class="wPL4o40ajO3bGEmyjpNf">
          <div
            class="G9JHenpYWEhrwkyqb33R"
            style="margin-bottom: 0.2rem; align-items: flex-start"
          >
            <div class="flex justify-center" style="flex-direction: column">
              <div class="G9JHenpYWEhrwkyqb33R">
                <p>{{ $t('components._Check_insconsecutivos') }}:</p>
                <span class="notranslate" style="margin-left: 0.06rem">{{
                  formDate.signed_days
                }}</span>
              </div>
              <span>disa</span>
            </div>

            <div class="G9JHenpYWEhrwkyqb33R">
              <p>{{ $t('components._Resgatado') }}&nbsp;</p>
              <span
                class="notranslate daV6P29LBSJRZ5JRmzrV"
                style="
                  color: var(--theme-label-secondary-color-finance);
                  border-bottom: thin solid
                    var(--theme-label-secondary-color-finance);
                "
                >{{ formDate.get_money }}</span
              >
              <div
                class="flex items-center"
                style="justify-content: end"
                @click="getNotification"
              >
                <svg-icon
                  classNameQita
                  icon-class="icon-reload"
                  class="item-svg"
                  :class="{
                    animate__manimated: animate__manimated
                  }"
                  style="
                    color: var(--theme-text-color-darken);
                    font-size: 0.2rem;
                    margin-left: 0.1rem;
                    vertical-align: text-bottom;
                    width: 0.28rem;
                    height: 0.28rem;
                  "
                />
              </div>
            </div>
          </div>
          <div class="receive-tips">
            Se você atender às condições hoje, mas falhar no check-in, poderá
            fazer o check-in no dia seguinte.
          </div>
          <div style="height: calc(100% - 2.01rem); overflow: scroll">
            <div v-if="formDate.list">
              <div v-for="item in formDate.list" class="_item_gtgop_52">
                <div
                  class="day"
                  :class="item.day == formDate.now_day ? 'active' : ''"
                >
                  <span>{{ item.day }}</span>
                </div>
                <div class="item-main">
                  <div class="item-info">
                    <div class="img-box">
                      <div class="img-bg"></div>
                      <img
                        class="lobby-image lobby-image lobby-image--skeleton picture"
                        data-load-strategy="loading-set@1:lazy@0"
                        data-status="success"
                        data-thumb="0"
                        data-id="25f03d03-970f-4960-8614-6c67895068e2"
                        src="https://oniw847.748win.cc/siteadmin/active/qd_style2_img_qdjb1.avif"
                        alt="."
                      />
                    </div>
                    <div class="info">
                      <div class="text day-num">
                        <!----><!---->
                        <p>Recompensa de check-in do dia {{ item.day }}</p>
                      </div>
                      <div class="text">{{ item.bonus }}</div>
                    </div>
                  </div>
                  <div
                    class="_caption_zocom_135"
                    v-if="formDate.now_day < item.day"
                  >
                    <span
                      style="
                        width: 1.3rem;
                        height: 0.5rem;
                        font-size: 0.22rem;
                        text-align: center;
                        border-radius: 0.5rem;
                        padding: 0 0.05rem;
                        border: 0.02rem solid var(--theme-bg-color);
                        line-height: 0.5rem;
                      "
                      >D {{ item.day }}</span
                    >
                  </div>
                  <div class="_caption_zocom_135" v-else>
                    <button
                      @click="ReceberTudo"
                      v-if="formDate.now_day == item.day"
                      class="van-button van-button--primary ui-button--success ui-button--normal _sign-btn_zocom_145"
                    >
                      <span class="ui-button__text">{{
                        $t('components._Entrar')
                      }}</span
                      ><!---->
                    </button>
                    <button
                      v-else
                      class="van-button van-button--primaryui-button--success ui-button--success ui-button--normal _sign-btn_zocom_145"
                    >
                      <span class="ui-button__text">{{
                        $t('components._Entrar')
                      }}</span
                      ><!---->
                    </button>
                  </div>
                </div>
                <!---->
              </div>
            </div>
            <div class="public-introduction _introduction_109ll_17">
              <div class="introduction-inner">
                <div class="_introduction-item_1j44v_99">
                  <div class="_introduction-title_cvq4f_52">
                    <div class="_title-container_cvq4f_52">
                      <span class="_title-text_cvq4f_70"
                        >Hora do evento (UTC-3)</span
                      ><i class="_arrow_cvq4f_87"></i>
                    </div>
                  </div>
                  <div>
                    <span
                      ><span dir="ltr">04/07/2026 00:00:00</span><span> - </span
                      ><span dir="ltr">31/07/2036 23:59:59</span></span
                    ><!---->
                  </div>
                </div>
                <div class="_introduction-item_1j44v_99">
                  <div class="_introduction-title_cvq4f_52">
                    <div class="_title-container_cvq4f_52">
                      <span class="_title-text_cvq4f_70"
                        >Descrição da atividade</span
                      ><i class="_arrow_cvq4f_87"></i>
                    </div>
                    <div class="">
                      1. O depósito diário e as apostas válidas devem cumprir as
                      condições da atividade para realizar o check-in. Após o
                      check-in bem-sucedido, o bônus correspondente pode ser
                      resgatado, até 18,88<br />2. Apenas apostas nas seguintes
                      plataformas são consideradas válidas, incluindo:<br />Slots:Todos
                      os jogos, a atualização das recompensas é prevista em 10
                      minutos, aguarde a distribuição<br />3. Esta atividade é
                      de check-in consecutivo. Se houver interrupção, começará
                      do dia 1<br />4. Se o check-in consecutivo atingir 7 dias,
                      o próximo check-in começará novamente do dia 1<br />5. As
                      recompensas só podem ser resgatadas manualmente no
                      dispositivo PC,Android_H5,iOS_H5,Android_APP,iOS_APP; as
                      não resgatadas serão canceladas<br />6. Se as condições
                      forem atendidas no dia, mas o check-in falhar, poderá ser
                      feita a compensação no dia seguinte, e os dias continuarão
                      a ser acumulados<br />7. O bônus concedido (excluindo o
                      capital) requer 1,00 vezes o valor de apostas válidas para
                      saque. As apostas são limitadas a<br />Não limitado a
                      plataformas de jogos<br />8. Esta atividade é limitada a
                      operações humanas normais pelo titular da conta. É
                      proibido aluguel, uso de robôs, apostas entre contas,
                      arbitragem ou exploração de falhas; caso contrário, as
                      recompensas serão canceladas ou a conta bloqueada<br />9.
                      Para evitar divergências de interpretação, a plataforma
                      reserva-se o direito de interpretação final
                    </div>
                  </div>
                </div>
                <div class="_introduction-item_1j44v_99">
                  <div class="_introduction-title_cvq4f_52">
                    <div class="_title-container_cvq4f_52">
                      <span class="_title-text_cvq4f_70"
                        >Termos e Condições</span
                      ><i class="_arrow_cvq4f_87"></i>
                    </div>
                    <div class="">
                      1. Cada jogador só pode usar uma conta. Contas múltiplas
                      são proibidas. Jogadores que abrirem contas múltiplas ou
                      fraudulentas serão desqualificados da atividade, e
                      quaisquer fundos restantes poderão ser confiscados e suas
                      contas congeladas.<br />2. Este site reserva-se o direito
                      de modificar, alterar, encerrar, cancelar ou recusar esta
                      atividade promocional a seu exclusivo critério.<br />3. Os
                      jogadores que participarem da atividade devem aceitar e
                      cumprir os termos desta atividade. A inscrição nesta
                      oferta significa a aceitação das regras da atividade e dos
                      termos correspondentes.<br />4. Para evitar ambiguidades,
                      este site reserva-se o direito de interpretação final
                      desta atividade.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          style="
            position: absolute;
            bottom: 0.25rem;
            padding: 0.2rem 0.2rem 0;
            z-index: 1000;
            width: calc(100% - 0.4rem);
          "
        >
          <div class="G9JHenpYWEhrwkyqb33R">
            <div class="G9JHenpYWEhrwkyqb33R">
              <p>
                {{ $t('menGMen._Valor') }} {{ $t('yuebao._Depositado') }}&nbsp;
              </p>
              <span class="notranslate daV6P29LBSJRZ5JRmzrV"
                ><span style="color: var(--theme-secondary-color-error)">{{
                  formDate.today_recharge_str
                }}</span
                >/{{ formDate.need_recharge }}</span
              >
            </div>
            <div class="G9JHenpYWEhrwkyqb33R">
              <p>
                {{ $t('menGMen._Valor') }} {{ $t('yuebao._Apostado') }}&nbsp;
              </p>
              <span class="notranslate daV6P29LBSJRZ5JRmzrV">
                <span style="color: var(--theme-secondary-color-error)">{{
                  formDate.today_bet_str
                }}</span
                >/{{ formDate.need_bet }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <MyToast
      :isShow="isMyToast"
      @cancel="isMyToast = false"
      @confirm="openConfirm"
      :model="{
        title: $t('components._Falhanocheckin'),
        message: message,
        buttomValue: $t('components._Irparadepsito'),
        type: 'fail' //success fail
      }"
    ></MyToast>

    <div
      class=""
      style="
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 0.4rem;
      "
    >
      <img
        style="width: 0.5984rem; height: 0.5984rem; cursor: pointer"
        @click="cunSltenmefals"
        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAABYCAMAAABGS8AGAAAAilBMVEUAAAD////e5Orv8vXe5Or////e5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Or////////h5+z8/f7z9ffm6/Dp7fHt8PT5+vv2+PrCEzcDAAAAJXRSTlMAYJYggoAJR6DVzbyRfHYuimpXKBlePTURrlDbxOm27OJwZaif1OMsUAAABGNJREFUWMPdmdtiojAQhlNAOSOoeK6tugRy4P1fb0lCO26DDRiv9r8Twsfkz0wSA/ovtVh6tzj8fP/4eP+M4iBdrpC93GtwJJQ1La+leNswisOgXNtQd9czpg2vNPGG4v1y/iR2lWDaVo9Ud2xv/YyxDmnqnsG77hOCOxFhC/+6znDuTsSuHdx89ZrgU5CW/nbluqutX6ZBJP1RYeN8kiEZZv2DJMr9nfbaZRL2/alZdJ3ignyIU5xvHzXaOJipVsQZaXWBG4UNi99zJuvR7LQcw00Il63xxdw2VTG02DO3dahqmuxG1Y8jw6iJY2g4V1wWH9BIFZEMmjoGLlPv302oI4eayYqLczRJKomoY/CX4wxNVI4F+bHPDpHcAk2Wp8gPcuOChQ/AnURWzx4GByEUiYNT9JQS0ds2HjSiEb1JnoDC+LABmzMCN55SIALDpVb4wn4eWSw4G0k4aR4x8b4rslAq+ky9HyOHlRFWujUiM34ELK9JI2zM0EJewyUbJVrIHuuufNpvQsT40QKB5IVsoOVsNnMRGnEDQuYh/F5S0QV9uX2rhN7QmBuQAwTWyX33osbRw6qU3nSukh5z3Hak/J/iIBut1awC8hC3mmmPlLQfLHDiiAbBQNa51R99CcL1nReOcCIZBgNZ50LEoHPHYl9pIOZLekCDHgNZ54LHoIx1QZ7758VQalUHECBrl3RtCSTYgYh5DSET2cgFkxcQfYDMZANX6dR2vi6/x455aAR5BBcFMHpiIGmJRpDNXDXt9MUW8c4VHxnII7mooN9pEXJZdwaymQvV1qoF6hPG0UQ2c5EPOfbRgfEKmcnANYHDEWAgA9cMBivswboVRzF4W3srYPD4SUs3+8G7iqw4qwJpoUDs0y2VEwQUYfqSAgEavONVJR3L/oPd0asmIVib5Jpd491rps3F3USPjjWkhe1EX1C5sQe/m/w1S9PtfnIvhcmh9WIKFm9grwnzm93yf5AWaxsj6w0LbNagDOt3yy0W9H3z75pNC+tNob7PduS+1mYbCwGy7D6tZRcuA/vrP7C/Nt/IGVTHXfrxI7LTSgacD/zhSezADvz1+nnRt+EWIjj2M7iF6EZztuC6IRd2zjXjqTx+sTCCQQJoRVOR9GkuqWTR6fJxLWwun+OmwmAeDuamR8S96PDUwMlDIVz8ckjSxk+Qr5hrxzOa/+1pshsXzH8feddpBBlfph67cdNpx0KSOZ5SgnOH1JI7R0ZyTZ3FWK6/Z5Xk7kzntrJdg7OxNvSHsfORPavpmOwoI1rD8bFJHm7l2TTZG+akZUz4pO4dYlbLB0hUrB96loVEBlDTYDN6oBPlXMUp3hergTG+xJjxSoXrTTrpupH2+8tPeEuXW3c37964c7eltz8SJu7KTpnzRzewqZTkFyHcS34TqnqsNgwjM5So7irVUvCbMwzmTtTCw6LTuuqWkShzkYV874T774TwpZDgON0ia7mHNDgdu++anT7ej3GQ+Wv0H+ov9UMLyPmx8boAAAAASUVORK5CYII="
      />
    </div>
  </van-popup>
</template>

<script>
import { dailySignIn, doDailySign } from '@/apis/modules/detail.js';
import MyToast from '@/components/MyToast/index.vue';
import { Toast } from 'vant';
import { mapState } from 'vuex';
export default {
  computed: {
    ...mapState(['vuex_token_head'])
  },
  components: {
    MyToast
  },
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    model: {
      type: [Object, Array],
      required: {}
    }
  },
  data() {
    return {
      isMyToast: false,
      codeValue: '',
      message: false,
      CancelDisplay: false,
      mesnComenste: false,
      inputFocus: false,
      formDate: {},
      animate__manimated: false
    };
  },
  created() {
    this.getNotification();
    setTimeout(() => {
      this.isShow = true;
    }, 1500);
  },
  methods: {
    getNotification() {
      this.animate__manimated = true;
      dailySignIn({}).then(({ code, data, msg }) => {
        //404
        this.formDate = data;
        let time = setTimeout(() => {
          clearTimeout(time);
          this.animate__manimated = false;
        }, 300);
      });
    },
    openConfirm() {
      this.isMyToast = false;
      this.mesnComenste = false;
      setTimeout(() => {
        this.$store.commit('isDeposit', true);
      }, 300);
    },
    checkLogin() {
      if (!this.vuex_token_head) {
        let rememberPassword = window.localStorage.getItem('rememberPassword');
        if (rememberPassword && rememberPassword.length) {
          this.$store.commit('isRecord');
          this.$store.commit('publicFun', ['isRecordType', 1]);
        } else {
          this.$store.commit('isRecord');
          this.$store.commit('publicFun', ['isRecordType', 0]);
        }
        return false;
      }
      return true;
    },
    ReceberTudo() {
      if (!this.checkLogin()) return;
      doDailySign({
        activity: 'lossSubsidy'
      }).then(({ code, data, msg }) => {
        //404
        if (code == 1) {
          this.isMyToast = true;
          this.message = msg;
          return false;
        } else if (code == 0) {
          Toast.success(msg);
          this.getNotification();
        } else {
          Toast.loading(msg);
        }
      });
    },
    cunSltenmefals() {
      this.$store.commit('publicFun', ['CancelIsSigned_days', false]);
      if (this.$store.state.isRefreshLoading) {
        setTimeout(() => {
          let alwaysShowDownload =
            this.$store.state.config.always_show_download;
          if (
            alwaysShowDownload &&
            !this.$store.state.config.hideAppDownload &&
            this.$store.state.config.download_give[0] == 'y'
          ) {
            this.$store.commit('publicFun', ['AppDownload', true]);
          } else {
            let inviteTime = localStorage.getItem('inviteTime');
            if (inviteTime) {
              if (inviteTime > new Date().getTime()) {
                this.$store.commit('publicFun', ['isCancelDisplay', false]);
              } else {
                this.$store.commit('publicFun', ['isCancelDisplay', true]);
              }
            } else {
              this.$store.commit('publicFun', ['isCancelDisplay', true]);
            }
            if (!this.$store.state.popList.length)
              this.$store.commit('publicFun', ['isCancelDisplay', false]);
            if (
              !this.$store.state.isCancelDisplay &&
              this.$store.state.first_recharge.status == 'show'
            ) {
              let isRechargeGiftTime =
                localStorage.getItem('isRechargeGiftTime');
              let isRechargeGift = localStorage.getItem('isRechargeGift');
              if (!isRechargeGift && !isRechargeGiftTime)
                this.$store.commit('publicFun', ['isRechargeGift', true]);
            }
          }
        }, 500);
      }
      // CancelIsSigned_days
    },
    openUrl(e) {
      if (e.jump_url && e.jump_url != '#') {
        this.$router.push({
          name: e.jump_url
        });
      }
    }
  }
};
</script>
<style>
.login-body {
  font-weight: 400;
}

.van-popup.advertisement_-conter {
  background-color: transparent;
}

.ZaAWGnvFuhPwlBk40od_.svg-icon {
  width: 0.24rem !important;
  height: 0.24rem !important;
  color: var(--theme-label-secondary-color-finance);
  margin-left: 0.15rem;
}
</style>
<style scoped>
._item_gtgop_52 {
  position: relative;
  z-index: 1;
  display: flex;
  height: 1.1rem;
  padding-bottom: 0.2rem;
}
._item_gtgop_52 .day {
  position: relative;
  width: 0.34rem;
  height: 100%;
  margin-right: 0.1rem;
  padding-top: 0.385rem;
}

._item_gtgop_52 .day span {
  position: relative;
  z-index: 10;
  display: inline-block;
  width: 0.34rem;
  height: 0.34rem;
  color: var(--theme-text-color-darken);
  font-size: 0.24rem;
  line-height: 0.34rem;
  text-align: center;
  border-radius: 50%;
  background: var(--theme-text-color);
}

._item_gtgop_52 .day.active span {
  color: var(--theme-main-bg-color);
  background-color: var(--theme-text-color-darken);
}

._item_gtgop_52 .day:after {
  position: absolute;
  top: 0.64rem;
  bottom: -0.2rem;
  left: 0.15rem;
  z-index: 9;
  width: 0.04rem;
  background: rgba(255, 255, 255, 0.6);
  content: '';
}
._item_gtgop_52 .day.active:after {
  background-color: var(--theme-text-color-darken);
}
._item_gtgop_52:last-child .day:after {
  display: none;
}

._item_gtgop_52 .item-main {
  display: flex;
  flex: 1;
  align-items: center;
  padding: 0.2rem;
  background: var(--theme-main-bg-color);
  border-radius: 0.14rem;
}

._item_gtgop_52 .item-main .item-info {
  display: flex;
  flex: 1;
  align-items: center;
}

._item_gtgop_52 .item-main .item-info .img-box {
  position: relative;
  width: 0.7rem;
  height: 0.7rem;
  margin-right: 0.2rem;
  overflow: hidden;
  line-height: 0.7rem;
  text-align: center;
  border-radius: 50%;
}

._item_gtgop_52 .item-main .item-info .img-box .img-bg {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 20;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.6);
  opacity: 0.3;
}

._item_gtgop_52 .item-main .item-info .info {
  flex: 1;
}

._item_gtgop_52 .item-main .item-info .info .day-num {
  display: flex;
  gap: 0.1rem;
  margin-bottom: 0.09rem;
}

._item_gtgop_52 .item-main .item-info .info .text p {
  color: var(--theme-text-color);
  font-size: 0.24rem;
}

._item_gtgop_52 .item-main .item-info .info .text {
  font-size: 0.22rem;
  line-height: 1.2;
  color: var(--theme-label-secondary-color-finance);
}

._item_gtgop_52 .item-main .item-info .img-box .picture {
  position: relative;
  z-index: 21;
  width: 100%;
  opacity: 1;
}

.wPL4o40ajO3bGEmyjpNf {
  background-color: var(--theme-bg-color);
  /* border: 0.01rem solid var(--theme-primary-color); */
  border-radius: 0.1rem;
  box-shadow: 0 0.03rem 0.09rem 0 rgba(255, 255, 255, 0.6);
  height: calc(100% - 0.5rem);
  padding: 0.25rem 0.2rem;
}

._introduction_109ll_17 .introduction-inner {
  padding: 0.2rem;
  overflow-y: auto;
  color: var(--theme-text-color);
  font-size: 0.26rem;
  line-height: 0.42rem;
  white-space: pre-wrap;
  word-break: break-word;
  background-color: var(--theme-main-bg-color);
  border-radius: 0.1rem;
  box-shadow: 0 0.03rem 0.09rem rgba(0, 0, 0, 0.06);
  overflow: visible;
}
._introduction_109ll_17 .introduction-inner .text-darken {
  font-weight: 700;
}

._introduction-item_1j44v_99 {
  margin-bottom: 0.2rem;
  font-size: 0.28rem;
  line-height: 0.42rem;
  white-space: pre-wrap;
  word-break: break-word;
}
._introduction-title_cvq4f_52 ._title-container_cvq4f_52 {
  position: relative;
  display: inline-block;
  left: -0.28rem;
  height: 0.62rem;
  margin-bottom: 0.2rem;
  max-width: 100%;
}

._introduction-title_cvq4f_52 ._title-container_cvq4f_52 ._title-text_cvq4f_70 {
  position: relative;
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding-left: 0.28rem;
  padding-right: 0.15rem;
  font-size: 0.32rem;
  height: 0.56rem;
  line-height: 0.56rem;
  background-color: var(--theme-text-color-darken);
  color: var(--theme-btm-bg-color);
  border-top-left-radius: 0.06rem;
  z-index: 1;
}

._introduction-title_cvq4f_52 ._title-container_cvq4f_52:before {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 0.08rem;
  height: 0.1rem;
  background-color: var(--theme-text-color-darken);
  border-bottom-left-radius: 0.06rem;
}
._introduction-title_cvq4f_52 ._title-container_cvq4f_52 ._arrow_cvq4f_87 {
  position: absolute;
  top: 0;
  right: -0.26rem;
  width: 0.28rem;
  height: 0.56rem;
  overflow: hidden;
  z-index: 0;
}
._introduction-title_cvq4f_52
  ._title-container_cvq4f_52
  ._arrow_cvq4f_87:before,
._introduction-title_cvq4f_52
  ._title-container_cvq4f_52
  ._arrow_cvq4f_87:after {
  content: '';
  position: absolute;
  top: -0.34rem;
  left: 0;
  border: 0.32rem solid transparent;
  border-left-color: var(--theme-text-color-darken);
}
._introduction-title_cvq4f_52
  ._title-container_cvq4f_52
  ._arrow_cvq4f_87:after {
  content: '';
  position: absolute;
  left: 0;
  border: 0.32rem solid transparent;
  border-left-color: var(--theme-text-color-darken);
  top: 0.26rem;
}

.van-button--primaryui-button--success {
  background-color: var(--theme-disabled-bg-color);
  border-color: var(--theme-disabled-bg-color);
  color: var(--theme-disabled-font-color);
}
._sign-item0_zocom_39 ._reward-pattern_zocom_54 {
  margin-top: 0;
}

._sign-item0_zocom_39 .sign-badge,
._sign-item6_zocom_158 .sign-badge {
  left: auto;
  right: -0.15rem;
}

._list_1rbyt_24 {
  display: flex;
  flex-wrap: wrap;
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  padding: 0.2rem 0 0.05rem 0.2rem;
  background-color: var(--skin__bg_2);
  border-radius: 0.14rem;
}

._sign-item0_zocom_39 {
  margin-right: 0.2rem;
}

._sign-item0_zocom_39:nth-child(3n) {
  margin-right: 0;
}

.sign-badge {
  position: absolute;
  top: 0;
  left: 50%;
  transform: none;
  right: auto;
  max-width: inherit !important;
  color: #ff0;
}

._reward-pattern_zocom_54 {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.24rem;
  height: 1.24rem;
  margin: 0.2rem auto 0;
}

._reward-pattern_zocom_54 .received-box {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

._reward-pattern_zocom_54 .received-box .bg-receive {
  position: absolute;
  top: 50%;
  left: 50%;
  font-size: 1.24rem;
  transform: translate(-50%, -50%);
}

._reward-pattern_zocom_54 .received-box .has-receive {
  display: block;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.1rem;
  height: 0.5rem;
  margin-top: 0.02rem;
  font-weight: 700;
  font-size: 0.22rem;
  line-height: 0.24rem;
  text-align: center;
  transform: scale(0.7) rotate(-18deg);
}

._reward-pattern_zocom_54 .received-box .has-receive .text {
  position: relative;
  top: 0;
  display: grid;
  line-height: 0;
}

._reward-pattern_zocom_54 .received-box .has-receive:lang(zh) {
  font-size: 0.32rem;
}

._reward-pattern_zocom_54 .received-box .has-receive:lang(en) {
  font-size: 0.32rem;
}

._reward-pattern_zocom_54 .received-box .has-receive:lang(pt) {
  font-size: 0.26rem;
}

._reward-pattern_zocom_54 .picture {
  display: block;
  width: 100%;
  height: 100%;
}

._reward-description_zocom_113 {
  margin-bottom: 0.01rem;
  padding: 0.01rem 0.1rem;
}

._reward-description_zocom_113 .divider {
  border-top: 0.01rem solid var(--theme-text-color);
}

._reward-description_zocom_113 .text-wrap {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  position: relative;
  width: 100%;
  height: 0.3rem;
  margin-bottom: 0.2rem;
  font-size: 0.22rem;
  line-height: 0.3rem;
  text-align: center;
}

._reward-description_zocom_113 .yellow {
  color: var(--skin__accent_3);
}

._caption_zocom_135 {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1.29;
}

._caption_zocom_135 ._sign-btn_zocom_145 {
  width: 1.44rem;
  height: 0.54rem;
  font-size: 0.22rem;
  text-align: center;
  border-radius: 0.5rem;
  padding: 0 0.05rem;
  border: 0.02rem solid var(--theme-bg-color);
}

._caption_zocom_135 ._sign-btn_zocom_145 .ui-button__text {
  word-break: break-word;
}

.advertisement_list {
  height: calc(100vh - 4.3rem);
}

.G9JHenpYWEhrwkyqb33R {
  -ms-flex-align: center;
  -ms-flex-pack: justify;
  align-items: center;
  display: flex;
  justify-content: space-between;
  color: var(--theme-text-color);
}

.xmHlf3AdKNfopQZxGTk7 {
  text-align: left;
  color: var(--theme-disabled-font-color);
  font-size: 0.24rem;
  height: 100%;
  position: relative;
}
.receive-tips {
  font-size: 0.24rem;
  margin-bottom: 0.2rem;
}

html .ant-btn.ant-btn-primary {
  width: 5rem;
  font-size: 0.24rem;
  background-color: var(--theme-primary-color);
  border-color: var(--theme-primary-color);
  margin-top: 0;
  display: flex;
  margin: 0 auto;
  text-align: center;
  align-items: center;
  justify-content: center;
}

html .ant-btn.ant-btn-primary {
  color: var(--theme-primary-font-color);
  text-shadow: none;
  height: 0.7rem;
  border-radius: 0.14rem;
}

.ZAJ3tO484KoZnr7Y6n_l {
  color: var(--theme-bg-color);
  height: 0.86rem;
  padding: 0;
  font-weight: 700;
  font-size: 0.28rem;
  text-align: left;
  display: flex;
  align-items: center;
  width: 7.1rem;
}

.RlMZ1IA0k4zaYVTGjIiN {
  color: var(--theme-text-color-darken);
  font-size: 0.22rem;
  margin-bottom: 0.4rem;
  margin-top: 0.3rem;
  min-height: 0.7rem;
}

.advertisement_list {
  width: 7.1rem;
  box-sizing: border-box;
  text-align: center;
  background-color: var(--theme-main-bg-color);
  border-radius: 0.2rem;
}

.advertisement_list .title {
  /* color: var(--theme-label-secondary-color-finance); */
  text-align: center;
  line-height: 1rem;
  font-size: 0.4rem;
}

._common-tabs-content {
  max-height: 5.4rem;
  width: 100%;
}

.consliTst {
  display: flex;
  align-items: center;
  border-radius: 0.1rem;
  height: 0.8rem !important;
  background-color: rgba(var(--theme-primay-color-hex), 0.05);
  max-width: 2.05rem;
  padding: 0.15rem;
  text-align: revert !important;
}

.consliTst svg {
  width: 0.38rem;
  height: 0.38rem;
  color: var(--theme-primary-color);
  margin-right: 0.08rem;
}

.consliTst span {
  font-size: 0.22rem;
  display: inline-block;
  line-height: 0.28rem;
  flex: 1;
  color: var(--theme-primary-color);
  overflow: hidden;
  text-overflow: ellipsis;
  /* white-space: nowrap; */
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  white-space: break-spaces !important;
}
</style>
